import axios from "axios"

import { apiDomain } from "../../store/constants"

const Plan = {
    getPlanForEdit (id) {
        return axios({
            url: apiDomain + `api/plan/${id}/edit`,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    editPlan (payload) {
        return axios({
            url: apiDomain + `api/plan/${payload.id}`,
            method: 'PUT',
            data: payload.data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default Plan